export default __webpack_public_path__ + "static/media/a_secure_life_best_overall_coverage_and_value.4a5154c6.png";